var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"empty-box"},[_c('div',[(_vm.isShowImg)?_c('img',{staticClass:"empty-img",style:({
                display: 'block',
                marginBottom: ((_vm.isShowImg ? 10 : 0) + "px")
            }),attrs:{"src":require("../assets/empty.png")}}):_vm._e(),_vm._v(" "),(_vm.isShowText)?_c('div',{staticStyle:{"color":"#7a7a7a","text-align":"center"}},[_vm._v("\n            "+_vm._s(_vm.text)+"\n        ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/extends/empty.vue